import React from 'react';
import { ArrowRight, Phone } from 'lucide-react';
import { contactInfo } from '../data/mock';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        role="img"
        aria-label="Premium sports car with custom vinyl wrap installed by WrapAlot Specialty Filmz in Sacramento, CA"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1619405399517-d7fce0f13302?q=80&w=2070&auto=format&fit=crop')`,
        }}
      />
      
      {/* Overlay */}
      <div className="absolute inset-0 bg-slate-900/75" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-32 md:py-40">
        <div className="max-w-2xl">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Transform Your{' '}
            <span className="text-cyan-400">Vehicle</span>
          </h1>
          
          <p className="text-lg md:text-xl text-gray-300 mb-10 leading-relaxed">
            Sacramento's trusted car wrap installation shop — premium vehicle wraps, custom graphics, and paint protection films.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={scrollToContact}
              className="flex items-center justify-center gap-2 bg-cyan-500 hover:bg-cyan-600 text-white px-8 py-4 rounded-lg font-semibold transition-all hover:scale-105 hover:shadow-lg hover:shadow-cyan-500/25"
            >
              Get a Free Quote
              <ArrowRight className="w-5 h-5" />
            </button>
            
            <a
              href={`tel:${contactInfo.phone}`}
              className="flex items-center justify-center gap-2 bg-transparent border-2 border-white/30 hover:border-white/50 text-white px-8 py-4 rounded-lg font-semibold transition-all hover:bg-white/5"
            >
              <Phone className="w-5 h-5" />
              {contactInfo.phone}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
